import React from 'react';
import cn from 'classnames';

import './penaltyCard.scss';

interface Props {
    typeCard: string;
}

const PenaltyCard: React.FC<Props> = ({ typeCard }) => (
    <div styleName={cn('penalty-card', typeCard)} />
);

export default PenaltyCard;
